import { createSlice } from "@reduxjs/toolkit"



const initialState={
    
    currentFarms:[],
    loading:false,
}

const farmsSlice=createSlice({
name:'farms',

initialState,
reducers:{
    loginStartF:(state)=>{
        state.loading=true

    },
    loginSuccessF:(state,{payload})=>{
        state.loading=false;
        state.currentFarms=payload;
        

    },
    loginFailureF:(state)=>{


    },
    logOutF:(state)=>{
        state.loading=false;
        state.currentFarms=[];

    }
    

}
})
export const {loginStartF,loginFailureF,loginSuccessF,logOutF}=farmsSlice.actions

export default farmsSlice.reducer